import { AbstractComponent } from "appworks/components/abstract-component";
// import { SmartUIManager } from "appworks/ui/smart-ui-manager";
// import { HeadlessSmartUIGroup } from "appworks/ui/ui-scene";
import { Signal } from "signals";

export class GambleComponent extends AbstractComponent {
    public static readonly DEFAULT: string = "default";
    public static readonly GAMBLE: string = "gamble";

    public onGambleStart: Signal = new Signal();
    public onGambleCollect: Signal = new Signal();

    // private SmartUIGroups: HeadlessSmartUIGroup[] = [];

    constructor() {
        super();

        // if (Layers.get("GambleControls").hasScene(GambleComponent.DEFAULT)) {
        //     const group = SmartUIManager.newSmartUIGroup(Layers.get("GambleControls"), GambleComponent.DEFAULT, "gamble");
        //     group.addEnableCondition([UIFlag.GAMBLE]);
        //     group.addDisableCondition([UIFlag.PROMPT]);
        //     group.addDisableCondition([UIFlag.AUTO_SPIN]);
        //     group.addDisableCondition([UIFlag.AWAITING_RESPONSE]);
        //     group.addDisableCondition([UIFlag.GAMBLE_UI]);
        //     group.addDisableCondition([UIFlag.MENU]);
        //     group.addDisableCondition([UIFlag.EXTERNAL_DISABLE]);

        //     this.SmartUIGroups.push(group);
        // }

        // if (Layers.get("GambleControls").hasScene(GambleComponent.GAMBLE)) {
        //     const group = SmartUIManager.newSmartUIGroup(Layers.get("GambleControls"), GambleComponent.GAMBLE, "gamble_ui");
        //     group.addEnableCondition([UIFlag.GAMBLE_UI]);
        //     group.addDisableCondition([UIFlag.PROMPT]);
        //     group.addDisableCondition([UIFlag.AUTO_SPIN]);
        //     group.addDisableCondition([UIFlag.AWAITING_RESPONSE]);
        //     group.addDisableCondition([UIFlag.MENU]);
        //     group.addDisableCondition([UIFlag.EXTERNAL_DISABLE]);

        //     this.SmartUIGroups.push(group);
        // }
    }

    public start(): void {
        this.onGambleStart.dispatch();
    }

    public collect(): void {
        this.onGambleCollect.dispatch();
    }
}
